import { Injectable } from '@angular/core';
import * as jwt from "jose"

@Injectable({
  providedIn: 'root'
})
export class ContractService {

  constructor() {}

  checkPermissionNumberInContract(numberToFind: number, currentSessionStorageIdContract: string): boolean {
    const permissions = JSON.parse(sessionStorage.getItem("PERMISSIONS") ?? "");
    for(const key in permissions) {
      if (key == currentSessionStorageIdContract) {
        const p: any[] = permissions[key]
        return p.some(x => x == numberToFind)
      }
    }
    return false;
  }
}
